import { inject, Injectable } from '@angular/core'

import { Observable } from 'rxjs'

import { BillingMode } from '@ti/contracts'
import { ApiService } from '@ti/core/api'
import { Memoize } from '@ti/core/common/decorators'
import { LanguageService } from '@ti/core/ui-kit/i18n'

@Injectable()
export class BillingModesProvider {
  protected readonly api = inject(ApiService)
  protected readonly languageService = inject(LanguageService)

  @Memoize()
  get labels$(): Observable<Record<BillingMode, string>> {
    const roleList = Object.values(BillingMode)
    const labelsMap: Record<string, string> = {}
    roleList.forEach((mode) => {
      labelsMap[mode as string] = `ti-admin.accounts.billing-mode.${mode}`
    })
    return this.languageService.massTranslate$(labelsMap)
  }
}
